import { baseAPI } from "../../baseApi";
import { tagsTypes } from "../../tagsTypes";

// Get product listing
export const specialOffersSlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getSpecialOffersOptions: builder.query({
      // Accept an object containing limit and page
      query: () => ({
        url: `product-schedule-options`,
        method: "GET",
      }),
      //   providesTags: [tagsTypes.GET_PRODUCT_LIST],
    }),
    getSpecialOffers: builder.query({
      query: (data) => ({
        url: `get-special-offers${data && "?"}${data}`,
        method: "GET",
      }),
      providesTags: [tagsTypes.GET_SPECIAL_OFFERS_LIST],
    }),
    createSpecialOfffer: builder.mutation({
      query: (data) => ({
        url: "create-special-offer",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_SPECIAL_OFFERS_LIST],
    }),
    deleteSpecialOfffer: builder.mutation({
      query: (id) => ({
        url: `delete-special-offer/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [tagsTypes.GET_SPECIAL_OFFERS_LIST],
    }),
  }),
});

export const {
  useGetSpecialOffersOptionsQuery,
  useCreateSpecialOffferMutation,
  useGetSpecialOffersQuery,
  useDeleteSpecialOffferMutation,
} = specialOffersSlice;
